export default {
      id: "detailed-contacts-usage",
      viewBox: "0 0 25 29",
      url: __webpack_public_path__ + "sprite.svg#detailed-contacts",
      toString: function () {
        return this.url;
      }
    }